// states/useMatchesState.js
import { useState } from "react";

export const useMatchesState = () => {
  const [matches, setMatches] = useState([]);
  const [errors, setErrors] = useState(null);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");
  const [competitions, setCompetitions] = useState([]);
  const [selectedCompetitionId, setSelectedCompetitionId] = useState("all");
  const [yearsList, setYearsList] = useState([]);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear().toString());
  const [currentLiveMatchIndex, setCurrentLiveMatchIndex] = useState(0);
  const [groupedMatches, setGroupedMatches] = useState({});
  const [liveMatches, setLiveMatches] = useState([]);
  const [apiKey, setApiKey] = useState(0);

  return {
    matches,
    setMatches,
    errors,
    setErrors,
    loading,
    setLoading,
    filter,
    setFilter,
    competitions,
    setCompetitions,
    selectedCompetitionId,
    setSelectedCompetitionId,
    yearsList,
    setYearsList,
    selectedYear,
    setSelectedYear,
    currentLiveMatchIndex,
    setCurrentLiveMatchIndex,
    groupedMatches,
    setGroupedMatches,
    liveMatches,
    setLiveMatches,
    apiKey,
    setApiKey,
  };
};